/**
 * @generated SignedSource<<02c873fd829b83773f6e4cd716be2802>>
 * @relayHash e279a48377b7737b706dfa93c69e92c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6cf392471e62cd1be0448a4a8325e310d19205fe38dd9ba1ecbd80f211e41a0b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DefaultFeaturesSettingsPageViewQuery } from './DefaultFeaturesSettingsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<DefaultFeaturesSettingsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6cf392471e62cd1be0448a4a8325e310d19205fe38dd9ba1ecbd80f211e41a0b",
    "metadata": {},
    "name": "DefaultFeaturesSettingsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
